import { render, staticRenderFns } from "./WorkflowFormSubmissionWorkflowCard.vue?vue&type=template&id=510323ce&"
import script from "./WorkflowFormSubmissionWorkflowCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionWorkflowCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormSubmissionWorkflowCard.vue?vue&type=style&index=0&id=510323ce&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports